import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Logo from "../../assets/logo.png"; // <-- Update your logo path
import "./login.css"
const API_URL_AUTH = "https://auth.ebslab.in/api";

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setIsLoading(true);

    try {
      const response = await axios.post(`${API_URL_AUTH}/userAuthLogin`, {
        username: email,
        password,
      });

      const { access_token } = response.data;

      if (!access_token) {
        setError("No access token received.");
        return;
      }

      onLogin(access_token);
    } catch (err) {
      setError(
        err.response?.data?.detail || "Login failed. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-lg-5 col-md-7 col-sm-10">
            <div className="card login-card border-0">
              <div className="card-body p-5">
                {/* Logo */}
                <div className="text-center mb-4">
                  <div className="logo-wrapper mx-auto mb-3">
                    <img
                      src={Logo}
                      alt="Logo"
                      className="login-logo"
                    />
                  </div>

                  <h2 className="fw-bold mb-1">Welcome Back</h2>
                  <p className="text-muted mb-0">Sign in to continue</p>
                </div>

                {error && (
                  <div className="alert alert-danger py-2">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>

                  {/* Email */}
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label fw-semibold">
                      Email Address
                    </label>

                    <input
                      id="email"
                      type="email"
                      className="form-control form-control-lg"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  {/* Password */}
                  <div className="mb-4 position-relative">
                    <label htmlFor="password" className="form-label fw-semibold">
                      Password
                    </label>

                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      className="form-control form-control-lg pe-5"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />

                    <button
                      type="button"
                      className="btn border-0 bg-transparent position-absolute end-0 top-50 translate-middle-y me-2 mt-3"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FaEyeSlash size={24} className="text-secondary fs-5" />
                      ) : (
                        <FaEye size={24} className="text-secondary fs-5" />
                      )}
                    </button>
                  </div>

                  <button
                    type="submit"
                    disabled={isLoading}
                    className="btn btn-primary btn-lg w-100 rounded-3 shadow-sm"
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Logging in...
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>

                  <div className="d-flex justify-content-between mt-4">
                    <span className="text-muted">Forgot your password?</span>

                    <Link to="#" className="text-decoration-none fw-semibold">
                      Reset Password
                    </Link>
                  </div>
                </form>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

LoginForm.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default LoginForm;